<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="none" viewBox="0 0 21 21"><path stroke="#fff" stroke-width="2" d="m2 11.087 5.918 5.38L19.675 3.378"/></svg>
</template>

<script>
  export default {
    name: "InputSuccess"
  }
</script>